import { useEffect } from 'react'
import Head from 'next/head'
import { useTranslation } from 'react-i18next'
import HeaderTitle from '../../components/HeaderTitle'
import NextLink from 'next/link'
import { useRouter } from 'next/router'
import { Box, Card, Container, Divider, Link, Typography } from '@mui/material'
import { GuestGuard } from '../../components/authentication/guest-guard'
import { JWTRegister } from '../../components/authentication/jwt-register'
import Logo from '../../components/theme-logo'
import { useAuth } from '../../hooks/use-auth'
import { gtm } from '../../lib/gtm'
import { useSettings } from '../../hooks/use-settings'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { siteConfig } from '../../config'

const Register = () => {
    const { t } = useTranslation()
    const { settings } = useSettings()
    const router = useRouter()
    const { disableGuard } = router.query

    useEffect(() => {
        gtm.push({ event: 'page_view' })
    }, [])

    return (
        <>
            <HeaderTitle>Register</HeaderTitle>

            <GoogleReCaptchaProvider reCaptchaKey={siteConfig.recaptchaKey}>
                <Box
                    component="main"
                    sx={{
                        backgroundColor: 'background.default',
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '100vh'
                    }}
                >
                    <Container
                        maxWidth="sm"
                        sx={{
                            py: {
                                xs: '60px',
                                md: '120px'
                            }
                        }}
                    >
                        <Card elevation={16} sx={{ p: 4 }}>
                            <Box
                                sx={{
                                    alignItems: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center'
                                }}
                            >
                                <NextLink href="/" passHref>
                                    <a>
                                        <Logo
                                            variant={settings.theme}
                                            sx={{
                                                height: 'auto',
                                                width: '230px'
                                            }}
                                        />
                                    </a>
                                </NextLink>
                                <Typography
                                    variant="h3"
                                    style={{ marginTop: 30 }}
                                >
                                    Register
                                </Typography>
                                <Typography
                                    color="textSecondary"
                                    sx={{ mt: 2 }}
                                    variant="body2"
                                >
                                    Register on the internal platform
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    mt: 3
                                }}
                            >
                                <JWTRegister />
                            </Box>
                            <Divider sx={{ my: 3 }} />
                            <NextLink
                                href={
                                    disableGuard
                                        ? `/authentication/login.html?disableGuard=${disableGuard}`
                                        : '/authentication/login.html'
                                }
                                passHref
                            >
                                <Link color="textSecondary" variant="body2">
                                    Go back to Log In
                                </Link>
                            </NextLink>
                        </Card>
                    </Container>
                </Box>
            </GoogleReCaptchaProvider>
        </>
    )
}

Register.getLayout = (page) => <GuestGuard>{page}</GuestGuard>

export default Register
